import React from 'react';
import ProcessBar from 'components/ProcessBar';
import InsureProcessCalc from 'components/InsureProcess/Travel/InsureProcessCalc';
import InsureProcessFill1st from 'components/InsureProcess/Travel/InsureProcessFill1st';
import InsureProcessFill2nd from 'components/InsureProcess/Travel/InsureProcessFill2nd';
import InsureProcessPreview from 'components/InsureProcess/Travel/InsureProcessPreview';
import InsureProcessPayment from 'components/InsureProcess/Travel/InsureProcessPayment';
import InsureProcessSuccess from 'components/InsureProcess/Travel/InsureProcessSuccess';
import SliderBoundless from 'components/SliderBoundless';
import { IProps, IState } from './types';
import { InsProcessStep } from 'constants/enums/insProcessStep.enum';
import service from 'bff/services/travelProductService';
import apiCommonService from 'bff/services/commonService';
import {
  Activity,
  Occupation,
  KycClaim,
  Postcode,
  TravelWarning,
  Activities,
  Code,
  EmailDomain,
  Inscat,
  SysOption
} from 'bff/models/info';
import _ from 'lodash';
import { connect } from 'react-redux';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import storageService from 'utils/storageService';
import { AddFavoriteItem, MemberProfile } from 'bff/models/member';
import { Dispatch } from 'redux';
import { RootReducersState } from 'redux/reducers';
import { addFavoriteItem, removeFavoriteItem, unloginAddItem } from 'redux/actions/components/myFavorite.action';
import { Link } from 'bff/models/link';
import { EvalRes, EvalReq, AgeLimitcnd, DATAReqContent, PolicyFeeReq } from 'bff/models/product';
import { EvalExpans } from 'constants/models/evalExpans';
import sweetAlertService from 'utils/sweetAlertService';
import { InsType } from 'constants/enums/insType.enum';
import { ApplyType } from 'constants/enums/applyType.enum';
import OTPVerificationForm from 'components/OTPVerificationForm';
import { OTPInfo } from 'bff/models/login';
import { PaymentMethod } from 'bff/models/product/paymentMethod';
import { SactionType } from 'constants/enums/sactionType.enum';
import { ICalcFormValue } from 'constants/models/components/insurProcess/insureProcessCalc';
import { IFill1stFormValue, IFill1stState, TravelWarningExpandData } from 'constants/models/components/insurProcess/insureProcessFill1st';
import { IFill2ndFormValue, IFill2ndState } from 'constants/models/components/insurProcess/insureProcessFill2nd';
import { IPaymentFormValue, IPaymentState } from 'constants/models/components/insurProcess/insureProcessPayment';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import commonService from 'utils/commonService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { IdInfoType } from 'constants/enums/idInfoType.enum';
import { TravelPlanType } from 'constants/enums/travelPlanType.enum';
import { InsureProcessTemp } from 'constants/models/insureProcessTemp';
import { CodeId } from 'constants/enums/codeId.enum';

const initState: IState = {
  inscat: {} as Inscat,
  activeStep: 0 as InsProcessStep,
  products: {
    PRODUCT: new Array(0),
    SPI_ATTACH: new Array(0)
  },
  insTypeId: '',
  prodId: '',
  programId: '',
  UICode: new Array(0),
  travelWarnings: new Array(0),
  tempCalc: {},
  tempFill1st: {},
  tempFill2nd: {},
  tempPayment: {}
};

class InsureProcess extends React.Component<IProps, IState> {
  state: IState = initState;

  componentDidMount = async () => {
    // console.log('uuid', this.props.match.params.uuid);

    // #region 判斷來源是否為後台

    if (this.props.match.params.uuid) {
      // console.log('補繳費');
      storageService.removeItem(storageKeys.InsurceProcessState);
      const boPaybyRes = await apiCommonService.boPayby(this.props.match.params.uuid);

      if (typeof boPaybyRes === 'string') {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${boPaybyRes}`
        }).then(() => {
          this.props.history.replace(RouterSettings.Home);
        });
        return;
      }

      this.setState({
        boPayby: { ...boPaybyRes }
      });

      await this.handleInitPayment(boPaybyRes.APPLY_NO);

      return;
    }

    // #endregion

    // 預設試算險種類別為旅平險
    let insTypeIdVal: string = InsType.Travel;
    // 商品 Id
    let prodIdVal: string = '';
    // 專案代碼
    let programIdVal: string = '';
    if (storageService.getItem(storageKeys.TravelActiveProdId)) {
      const temp = JSON.parse(storageService.getItem(storageKeys.TravelActiveProdId)) as InsureProcessTemp;

      prodIdVal = temp.PROD_ID || '';
      insTypeIdVal = temp.INS_TYPE_ID || InsType.Travel;
      programIdVal = temp.PROGRAM_ID || '';
    }

    // 登入狀態，若為外國人，不可投保 國內 國外 申根
    // 若是清除暫存資料，且導回商品頁
    if (storageService.getItem(storageKeys.MemberId)) {
      const memberId = storageService.getItem(storageKeys.MemberId);
      const validChar = memberId ? memberId[1] : '';

      // 若為外國人，不可投保 國內 國外 申根
      let prodError = validChar &&
        (validChar !== IdInfoType.NationalMale && validChar !== IdInfoType.NationalFemale) &&
        (prodIdVal === TravelPlanType.Domestic || prodIdVal === TravelPlanType.Abroad || prodIdVal === TravelPlanType.NTAG || prodIdVal === TravelPlanType.TBP);

      // 無商品代碼，且有暫存資料，判斷試算頁選取的商品種類，若為外國人，不可投保 國內 國外 申根
      if (!prodIdVal && storageService.getItem(storageKeys.InsurceProcessState)) {
        const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessState));
        const formVal = tempData.tempCalc.tempCalcFormVal as ICalcFormValue;

        prodError = validChar &&
          (validChar !== IdInfoType.NationalMale && validChar !== IdInfoType.NationalFemale) &&
          (formVal.PROD_ID === TravelPlanType.Domestic || formVal.PROD_ID === TravelPlanType.Abroad || formVal.PROD_ID === TravelPlanType.NTAG || formVal.PROD_ID === TravelPlanType.TBP);
      }

      if (prodError) {
        storageService.removeItem(storageKeys.InsurceProcessState);

        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          // html: '此商品尚未提供非本國人投保，請確認'
          html: `${commonService.getCodeMsg(this.state.UICode, CodeId.W073)}`
        }).then(() => {
          this.props.history.push(RouterSettings.Product.TravelIns);
        });
        return;
      }
    }

    // #region 判斷有無暫存資料

    // 有暫存資料且暫存資料已到期，刪除暫存資料
    if (storageService.getItem(storageKeys.InsurceProcessState)) {
      const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessState));
      const isChangeProdId = this.handleValidProdIdChange(insTypeIdVal, prodIdVal, tempData);

      if (isChangeProdId || moment().isAfter(tempData.expiredDate)) {
        storageService.removeItem(storageKeys.InsurceProcessState);
      }
    }

    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessState));
    // const loginInfo = storageService.getItem(storageKeys.LoginInfo);

    if (tempData) {
      // console.log('設定暫存資料');
      this.setState({
        ...tempData
      });

      return;
    }

    // #endregion

    // #region 基本進入頁面
    const initSettingRes = await service.fetchInitSetting(insTypeIdVal);

    this.setState({
      activeStep: InsProcessStep.InsureProcessCalc,
      products: { ...initSettingRes.products },
      UICode: [...initSettingRes.UICode],
      travelWarnings: [...initSettingRes.travelWarnings],
      insTypeId: insTypeIdVal,
      prodId: prodIdVal,
      programId: programIdVal
    });

    // const initSettingRes = await service.fetchTempState();
    // this.setState({ ...initSettingRes });

    // #endregion
  }

  componentDidUpdate () {
    // console.log('componentDidUpdate', this.state);
    // console.log('InsureProcess componentDidUpdate');
  }

  /**
   * @description 判斷選取的方案是否改變，決定是否清除暫存
  */
  handleValidProdIdChange = (insTypeId: string, prodId: string, tempData: any) => {
    const formVal = tempData.tempCalc.tempCalcFormVal as ICalcFormValue;
    if (formVal && formVal.PROD_ID) {
      return insTypeId !== formVal.INS_TYPE_ID || prodId !== formVal.PROD_ID;
    }

    return insTypeId !== tempData.insTypeId || prodId !== tempData.prodId;
  }

  /**
   * @description 試算頁頁面結束事件
  */
  handleInsureProcessCalcUnmount = (
    tempCalcFormVal: ICalcFormValue, evalReq: EvalReq, evalInfo: EvalRes, evalExpanData: EvalExpans[], activeTouristArea: string, tempTravels: TravelWarningExpandData[]) => {
    const newState = {
      ...this.state,
      tempCalc: {
        ...this.state.tempCalc,
        tempCalcFormVal: { ...tempCalcFormVal },
        evalReq: evalReq,
        evalInfo: evalInfo,
        evalExpanData: evalExpanData,
        activeTouristArea,
        tempTravels
      }
    };

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  /**
   * @description 初始化 填寫資料 Page 1
  */
  handleInitProcessFill1st = async (
    tempCalcFormVal: ICalcFormValue, evalReq: EvalReq, evalInfo: EvalRes,
    evalExpanData: EvalExpans[], planData: EvalExpans, maxPeriod: number,
    activeTouristArea: string, tempTravels: TravelWarningExpandData[]
  ) => {
    const res = await service.fetchInitProcessFill1st();
    this.setState({
      activeStep: InsProcessStep.InsureProcessFill1st,
      tempCalc: {
        tempCalcFormVal: { ...tempCalcFormVal },
        evalInfo: { ...evalInfo },
        evalExpanData: [...evalExpanData],
        planData: { ...planData },
        evalReq: { ...evalReq },
        maxPeriod: maxPeriod,
        activeTouristArea,
        tempTravels
      },
      travelWarnings: [...res.travelWarnings],
      docLinks: [...res.docLinks],
      quickClaimCode: [...res.quickClaimCode]
    });
  }

  /**
   * @description 填寫資料 Page 1 頁面結束事件
  */
  handleInitProcessFill1Unmount = (tempFill1stFormVal: IFill1stFormValue, tempFill1stState: IFill1stState) => {
    const newState = {
      ...this.state,
      tempFill1st: {
        tempFill1stFormVal: { ...tempFill1stFormVal },
        tempFill1stState: { ...tempFill1stState }
      },
      tempCalc: { ...tempFill1stState.editedTempCalc }
    };

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  /**
   * @description 調整日期，重新試算保費
   */
   handleReCalcFillst = async (planData: EvalExpans, startDate: any, endDate: any) => {
     if (this.state.tempFill2nd.tempFill2ndFormVal) {
       const insureds = this.state.tempFill2nd.tempFill2ndFormVal.INSUREDS;
       if (!(insureds.length === 1 && insureds[0].INSURED_AMT === '')) {
         for (let i = 0; i < insureds.length; i++) {
           const insured = insureds[i];
           if (insured.INSURED_AMT_OPTS) {
             const dataReqContent: DATAReqContent = {
               ID: insured.INSURED_ID,
               BIRTHDAY: moment(insured.INSURED_BIRTHDAY).format('YYYYMMDD'),
               LIFE: +insured.INSURED_AMT,
               MEDICAL: +insured.INSURED_MEDICAL_VALUE,
               MFUNERAL: 0
             };

             // 建立保費計算用 Request Model
             const policyReq: PolicyFeeReq = {
               INS_TYPE_ID: planData.INS_TYPE_ID,
               PROD_ID: planData.PROD_ID,
               PLAN_ID: planData.HEADER.PLAN_ID,
               CLASS: '1',
               START_DATE: moment(startDate).format('YYYYMMDD'),
               END_DATE: moment(endDate).format('YYYYMMDD'),
               DATA: [{ ...dataReqContent }]
             };
             const response = await service.fetchPolocyFee(policyReq);
             if (response && typeof response !== 'string') {
               const fee = response.DATA[0].FEE;
               insureds[i].INSURED_CALC = fee.toString();
             }
           }
         }
         this.setState({
           tempFill2nd: {
             tempFill2ndFormVal: {
               ...this.state.tempFill2nd.tempFill2ndFormVal,
               INSUREDS: insureds
             }
           }
         });
       }
     }
   }

  /**
   * @description 填寫資料 Page 1 我要修改方案 事件
  */
  handleOnEditPlan = (tempFill1stFormVal: IFill1stFormValue, tempFill1stState: IFill1stState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessCalc,
      tempFill1st: {
        tempFill1stFormVal: {
          ...tempFill1stFormVal,
          TOURIST_COUNTRY: '',
          TOURIST_DESTINATION: ''
        },
        tempFill1stState: {
          ...tempFill1stState,
          activeTouristArea: '',
          tempTravels: new Array(0)
        }
      },
      tempCalc: { ...tempFill1stState.editedTempCalc }
    });
  }

  /**
   * @description 暫存資料填寫頁 2 資料
  */
  handleFill2ndTempData = () => {
    this.setState({ activeStep: 0 });
  }

  /**
   * @description 資料填寫頁 2 頁面結束事件
  */
  handleProcessFill2Unmount = (tempFill2ndFormVal: IFill2ndFormValue, tempFill2ndState: IFill2ndState) => {
    let newState;
    this.state.activeStep
      ? newState = {
        ...this.state,
        tempCalc: {
          ...this.state.tempCalc,
          planData: { ...tempFill2ndState.planData } as EvalExpans,
          maxPeriod: this.state.tempCalc.maxPeriod
        },
        tempFill2nd: {
          tempFill2ndFormVal: { ...tempFill2ndFormVal },
          tempFill2ndState: { ...tempFill2ndState }
        }
      }
      : newState = {
        ...this.state,
        activeStep: InsProcessStep.InsureProcessFill2nd
      }
    ;

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  /**
    * @description 初始化 填寫資料 Page 2
   */
  handleInitProcessFill2nd = async (tempFill1stFormVal: IFill1stFormValue, tempFill1stState: IFill1stState) => {
    const res = await service.fetchInitProcessFill2nd(this.state.insTypeId, tempFill1stState.editedTempCalc?.tempCalcFormVal?.PROD_ID as string);
    this.setState({
      activeStep: InsProcessStep.InsureProcessFill2nd,
      tempCalc: {
        ...tempFill1stState.editedTempCalc,
        maxPeriod: this.state.tempCalc.maxPeriod
      },
      tempFill1st: {
        tempFill1stFormVal: { ...tempFill1stFormVal },
        tempFill1stState: { ...tempFill1stState }
      },
      kycClaims: [...res.kycClaims],
      occupations: [...res.occupations],
      postcodes: [...res.postcodes],
      emailDomains: [...res.emailDomains],
      ageLimitcnd: { ...res.ageLimitcnd }
    });
  }

  /**
   * @description 資料填寫頁 2 回到 資料填寫頁 1
  */
  handleProcessFill2GoBack = (tempFill2ndFormVal: IFill2ndFormValue, tempFill2ndState: IFill2ndState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessFill1st,
      tempCalc: {
        ...this.state.tempCalc,
        planData: { ...tempFill2ndState.planData } as EvalExpans,
        maxPeriod: this.state.tempCalc.maxPeriod
      },
      tempFill2nd: {
        tempFill2ndFormVal: { ...tempFill2ndFormVal },
        tempFill2ndState: { ...tempFill2ndState }
      }
    });
  }

  /**
   * @description 初始化資料預覽頁
  */
  handleInitProcessPreview = (tempFill2ndFormVal: IFill2ndFormValue, tempFill2ndState: IFill2ndState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessPreview,
      tempCalc: {
        ...this.state.tempCalc,
        planData: { ...tempFill2ndState.planData } as EvalExpans
      },
      tempFill2nd: {
        tempFill2ndFormVal: { ...tempFill2ndFormVal },
        tempFill2ndState: { ...tempFill2ndState }
      }
    });
  }

  /**
   * @description 資料瀏覽頁點選下一步進行導頁判斷
  */
  handleProcessPreviewNext = async () => {
    const applyType = this.state.tempFill2nd.tempFill2ndState?.applyType;
    // 案件來源為網投進行OTP驗證後再導至付款頁
    if (applyType === ApplyType.WebInsured) {
      // 進行 OTP
      await this.handleFetchOTP(false);
      return;
    }

    await this.handleInitPayment(this.state.tempFill2nd.tempFill2ndState?.serialNo || '');
  }

  /**
    * @description 取得 OTP 驗證碼方法
    * @param memberProfile 會員基本資料
    * @param isReSent 是否為重新發送
   */
  handleFetchOTP = async (isReSent?: boolean) => {
    const tempFill2ndFormVal = { ...this.state.tempFill2nd.tempFill2ndFormVal } as IFill2ndFormValue;
    const memberId = tempFill2ndFormVal.MEMBER_ID;
    const mobile = tempFill2ndFormVal.MOBILE;
    const emailAddr = tempFill2ndFormVal.EMAIL_ADDR;

    const result = await apiCommonService.fetchOTP({ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile, SactionType.Insurce, isReSent);
    if (result) {
      this.setState({
        activeStep: InsProcessStep.InsureProcessVerifyOTP,
        otpInfo: { ...result.TRANRS },
        getOTPTime: new Date().getTime()
      });
    }
  }

  /**
    * @description 驗證 OTP 驗證碼方法
    * @param otpVerificationReq OTP 驗證頁 Request Model
   */
  handleVerifyOTP = async (otpCode: string) => {
    const result = await apiCommonService.verifyOTP(this.state.otpInfo as OTPInfo, otpCode, SactionType.Insurce, false);

    if (typeof result === 'string') {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '驗證碼輸入有誤'// 'OTP驗證失敗',
        // html: result
      });

      return;
    }

    if (result) {
      await this.handleInitPayment(this.state.tempFill2nd.tempFill2ndState?.serialNo || '');
    }
  }

  /**
    * @description OTP 驗證碼頁面點選返回上一頁或無法取得驗證碼時的方法
    */
  handleReSetProfile = () => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessPreview,
      otpInfo: undefined,
      getOTPTime: undefined
    });
  };

  /**
   * @description 初始化確認付款頁
   * @param serialNo 要保單號
  */
  handleInitPayment = async (serialNo: string) => {
    const initRes = await service.fetchInitPayment(serialNo, this.state.insTypeId);
    this.setState({
      activeStep: InsProcessStep.InsureProcessPayment,
      paymentMethod: { ...initRes.paymentMethod },
      barcodeNoteCodes: [...initRes.barcodeNoteCodes],
      barcodeNoticeCodes: [...initRes.barcodeNoticeCodes]
    });
  }

  /**
   * @description 確認付款頁頁面結束事件
   */
  handlePaymentUnmount = (tempPaymentFormVal: IPaymentFormValue, tempPaymentState: IPaymentState) => {
    const newState = {
      ...this.state,
      tempPayment: {
        tempPaymentFormVal: { ...tempPaymentFormVal },
        tempPaymentState: { ...tempPaymentState }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessState, newState);
  }

  /**
   * @description 確認付款頁，返回預覽頁
   */
  handlePaymentGoBack = (tempPaymentFormVal: IPaymentFormValue, tempPaymentState: IPaymentState) => {
    this.setState({
      activeStep: InsProcessStep.InsureProcessPreview,
      tempPayment: {
        tempPaymentFormVal: { ...tempPaymentFormVal },
        tempPaymentState: { ...tempPaymentState }
      }
    });
  }

  /**
   * @description 初始化 成功投保頁
  */
  handleInitProcessSucess = async (tempPaymentFormVal: IPaymentFormValue, tempPaymentState: IPaymentState) => {
    const insTypeId = this.state.boPayby ? this.state.boPayby.INS_TYPE_ID : this.state.insTypeId;
    const res = await service.fetchInitProcessSuccess(insTypeId);

    this.setState({
      activeStep: InsProcessStep.InsureProcessSuccess,
      activities: { ...res.activities as Activities },
      tempPayment: {
        tempPaymentFormVal: { ...tempPaymentFormVal },
        tempPaymentState: { ...tempPaymentState }
      },
      insDoneCode: [...res.insDoneCode],
      insDoneBarCode: [...res.insDoneBarCode]
    });

    storageService.removeItem(storageKeys.InsurceProcessState);
    storageService.removeItem(storageKeys.TravelActiveProdId);
  }

  /**
    * @description 成功投保頁，顯示熱門活動 Slider
   */
  handleCreateSlider = () => {
    let sliderBar;
    if (this.state.activities && this.state.activities.ACTIVITY.length > 0) {
      const child = _.map(this.state.activities.ACTIVITY, (activity: Activity, index: number) => {
        return (
          <SliderBoundless.Item key={index}>
            <a href={activity.ACTIVITY_URL} target="_blank" rel="noopener noreferrer">
              <img src={activity.IMAGE_NAME_PC} alt={activity.TITLE} />
            </a>
          </SliderBoundless.Item>
        );
      });
      sliderBar = (
        <div>
          <div className="insure-process__slider-section">
            <SliderBoundless name="insure-process__slider">
              {child}
            </SliderBoundless>
          </div>
        </div>
      );
    }

    return sliderBar;
  }

  render () {
    const tempFill2ndFormVal = { ...this.state.tempFill2nd.tempFill2ndFormVal } as IFill2ndFormValue;
    const memberId = tempFill2ndFormVal.MEMBER_ID;
    const mobile = tempFill2ndFormVal.MOBILE;
    const emailAddr = tempFill2ndFormVal.EMAIL_ADDR;

    let activePage;
    let successSlider = null; // 成功投保 - Slider
    switch (this.state.activeStep) {
      case InsProcessStep.InsureProcessSuccess: // 成功投保
        activePage = <InsureProcessSuccess
          tempFill1st={this.state.tempFill1st}
          tempPayment={this.state.tempPayment}
          tempFill2nd={this.state.tempFill2nd}
          insDoneCode={this.state.insDoneCode as Code[]}
          insDoneBarCode={this.state.insDoneBarCode as Code[]}
          boPayby={this.state.boPayby}
          tempState={this.state}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        successSlider = this.handleCreateSlider();
        break;
      case InsProcessStep.InsureProcessPayment: // 確認付款
        activePage = <InsureProcessPayment
          UICode={this.state.UICode as Code[]}
          paymentMethod={this.state.paymentMethod as PaymentMethod}
          barcodeNoteCodes={this.state.barcodeNoticeCodes as Code[]}
          barcodeNoticeCodes={this.state.barcodeNoticeCodes as Code[]}
          tempCalc={this.state.tempCalc}
          tempFill1st={this.state.tempFill1st}
          tempFill2nd={this.state.tempFill2nd}
          tempPayment={this.state.tempPayment}
          onSubmit={this.handleInitProcessSucess}
          onGoBack={this.handlePaymentGoBack}
          boPayby={this.state.boPayby}
          tempState={this.state}
          onUnmount={this.handlePaymentUnmount}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessVerifyOTP:
        activePage = <OTPVerificationForm
          memberProfile={{ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile}
          memberId={memberId}
          otpInfo={this.state.otpInfo as OTPInfo}
          getOTPTime={this.state.getOTPTime as number}
          UICode={this.state.UICode as Code[]}
          onUnavailableAuth={this.handleReSetProfile}
          onGoBack={this.handleReSetProfile}
          onSubmit={this.handleVerifyOTP}
          onResentOTP={() => this.handleFetchOTP(true)}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessPreview: // 資料預覽
        activePage = <InsureProcessPreview
          postcodes={this.state.postcodes as Postcode[]}
          onPreviewCheck={this.handleProcessPreviewNext}
          onGoBack={() => this.setState({ activeStep: InsProcessStep.InsureProcessFill2nd })}
          tempCalcFormVal={this.state.tempCalc.tempCalcFormVal as ICalcFormValue}
          tempFill1st={this.state.tempFill1st}
          tempFill2nd={this.state.tempFill2nd}
          UICode={this.state.UICode}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessFill2nd: // 填寫資料 Page 2
        activePage = <InsureProcessFill2nd
          tempCalcFormVal={this.state.tempCalc.tempCalcFormVal as ICalcFormValue}
          occupations={this.state.occupations as Occupation[]}
          kycClaims={this.state.kycClaims as KycClaim[]}
          postcodes={this.state.postcodes as Postcode[]}
          tempCalc={this.state.tempCalc}
          tempFill1st={this.state.tempFill1st}
          tempFill2nd={this.state.tempFill2nd}
          UICode={this.state.UICode as Code[]}
          emailDomains={this.state.emailDomains as EmailDomain[]}
          onSubmit={this.handleInitProcessPreview}
          onGoBack={this.handleProcessFill2GoBack}
          ageLimitcnd={this.state.ageLimitcnd as AgeLimitcnd}
          tempState={this.state}
          onTempData={this.handleFill2ndTempData}
          onUnmount={this.handleProcessFill2Unmount}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessFill1st: // 填寫資料 Page 1
        activePage = <InsureProcessFill1st
          tempCalc={this.state.tempCalc}
          tempFill1st={this.state.tempFill1st}
          docLinks={this.state.docLinks as Link[]}
          travelWarnings={this.state.travelWarnings as TravelWarning[]}
          UICode={this.state.UICode as Code[]}
          quickClaimCode={this.state.quickClaimCode as Code[]}
          tempInsureds={this.state.tempFill2nd.tempFill2ndFormVal?.INSUREDS || new Array(0)}
          onReCalcFillst={this.handleReCalcFillst}
          onEditPlan={this.handleOnEditPlan}
          onSubmit={this.handleInitProcessFill2nd}
          tempState={this.state}
          onUnmount={this.handleInitProcessFill1Unmount}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case InsProcessStep.InsureProcessCalc: // 我要試算
        activePage = <InsureProcessCalc
          programId={this.state.programId}
          insTypeId={this.state.insTypeId}
          prodId={this.state.prodId}
          products={this.state.products}
          UICode={this.state.UICode}
          myFavoriteList={this.props.myFavoriteList}
          onAddFavoriteItem={this.props.onAddFavoriteItem}
          onRemoveFavoriteItem={this.props.onRemoveFavoriteItem}
          unloginAddItem={this.props.unloginAddItem}
          tempCalcFormVal={this.state.tempCalc.tempCalcFormVal as ICalcFormValue}
          evalInfo={this.state.tempCalc.evalInfo as EvalRes}
          evalExpanData={this.state.tempCalc.evalExpanData as EvalExpans[]}
          onCalc={() => {}}
          onInsured={this.handleInitProcessFill1st}
          tempState={this.state}
          onUnmount={this.handleInsureProcessCalcUnmount}
          travelWarnings={this.state.travelWarnings as TravelWarning[]}
          activeTouristArea={this.state.tempCalc.activeTouristArea}
          tempTravels={this.state.tempCalc.tempTravels}
          explainModalData={this.state.tempCalc.explainModalData as string[][]}
          explainModalTitleOpts={this.state.tempCalc.explainModalTitleOpts as SysOption[]}
          policyAgeLimitOpts={this.state.tempCalc.policyAgeLimitOpts as SysOption[]}
          insuredAgeLimitOpts={this.state.tempCalc.insuredAgeLimitOpts as SysOption[]}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
    }

    return (
      <div className={`insure-process insure-process--${InsTypeDefinesEN[InsType.Travel]}`}>
        <div className="insure-process__header">
          <ProcessBar activeStep={this.state.activeStep} />
        </div>
        <div className="insure-process__content">
          <div className="template-container">
            <div className="template-content">
              {activePage}
            </div>
          </div>
        </div>

        {/* 成功投保 - Slider */}
        {successSlider}

      </div>
    );
  }
};

const mapStateToProps = (state: RootReducersState) => {
  return {
    myFavoriteList: state.myFavorite.myFavoriteList
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    onAddFavoriteItem: (item: AddFavoriteItem) => dispatch(addFavoriteItem(item)),
    onRemoveFavoriteItem: (sn: any) => dispatch(removeFavoriteItem(sn)),
    unloginAddItem: (insTypeId: string, prodId: string, planId: string) => dispatch(unloginAddItem(insTypeId, prodId, planId))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(InsureProcess);
